import {FC, useState} from "react";
import {Box} from "@mui/material";
import {useGetUserRecommendedCourses, RecommendedCourseDto} from "@/app2/shared/data";
import { CustomToolbar } from "@/components/admin/bulkEnrollment/CustomToolbar";
import { DataGridPro, GridColDef, GridSelectionModel } from "@mui/x-data-grid-pro";

interface UserTrainingPoolTabProps {
	userId: number;
}

/**
 * Admin view of a user's training pool (recommended courses)
 *
 * Shows courses that could be auto-assigned based on weighting.
 */
export const UserTrainingPoolTab: FC<UserTrainingPoolTabProps> = ({userId}) => {
	const {data, isLoading} = useGetUserRecommendedCourses(userId);
	const [selectedIds, setSelectedIds] = useState<GridSelectionModel>([]);

	const columns: GridColDef<RecommendedCourseDto>[] = [
		{
			field: "title",
			headerName: "Course",
			flex: 1,
			minWidth: 240
		},
		{
			field: "contentType",
			headerName: "Content Type",
			flex: 1
		},
		{
			field: "score",
			headerName: "Weighting",
			width: 120,
			type: "number"
		},
		{
			field: "description",
			headerName: "Description",
			flex: 2,
			valueGetter: (params) => params.row.description ?? "-"
		}
	];

	return (
		<Box>
			<DataGridPro
				rows={data?.data ?? []}
				columns={columns}
				loading={isLoading}
				getRowId={(row) => row.id}
				checkboxSelection
				disableSelectionOnClick
				selectionModel={selectedIds}
				onSelectionModelChange={setSelectedIds}
				rowsPerPageOptions={[25, 50, 100, 200]}
				components={{Toolbar: (): JSX.Element => <CustomToolbar />}}
				initialState={{
					pagination: {pageSize: 25},
					sorting: {sortModel: [{field: "score", sort: "desc"}]}
				}}
				autoHeight
				sx={{
					"& .MuiDataGrid-row": {cursor: "default"}
				}}
			/>
		</Box>
	);
};

